import { reduxForm, formValueSelector, change } from 'redux-form';
import { connect } from 'react-redux';
import { compose, withProps } from 'react-recompose';
import Address from './Address';
import { deliveryAddressSelector } from '../../../modules/SignUp/DeliveryAddress/reducer';
import { confirmDeliveryAddress } from '../../../modules/SignUp/DeliveryAddress/actions';
import I18n from '../../../lib/i18n';
import { isLoadingSelector } from '../../../modules/LoadingStatus';
import type { DeliveryAddressFlaggedProps as FlaggedProps } from './Address';
import config from '../../../config';
import validate from './validation';
import { wrapComponentWith } from '../../../lib/hoc';
import { GradientPage } from '../../../components/common';
import { setDeliveryContact } from '../../../modules/SignUp/DeliveryContact';

const mapStateToProps = state => ({
  isLoading: isLoadingSelector(state, 'confirmDeliveryAddress'),
  initialValues: deliveryAddressSelector(state),
  address: deliveryAddressSelector(state),
  postCode: formValueSelector('deliveryAddress')(state, 'postCode'),
});

const mapDispatchToProps = dispatch => ({
  onSubmit: values => {
    dispatch(confirmDeliveryAddress(values));
    dispatch(setDeliveryContact({ name: values.fullName }));
  },
  changeFormField: (fieldName: string, fieldValue: string) =>
    dispatch(change('deliveryAddress', fieldName, fieldValue)),
});

const withFlaggedProps = (): FlaggedProps => ({
  title: I18n.t('SignUp.DeliveryAddress.title'),
  inferStateOrProvinceFromPostCode: config.inferAddressStateOrProvinceFromPostCode,
  displayFullName: config.askPersonalInformationDuringOrderSim,
  isFullNameDisabled: false,
  displayHouseNumber: config.displayHouseNumber,
});

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(withFlaggedProps),
  reduxForm({ form: 'deliveryAddress', validate }),
  wrapComponentWith(GradientPage)
);
export default enhance(Address);
